import { render, staticRenderFns } from "./issueReplyInput.vue?vue&type=template&id=f86825d4&scoped=true&"
import script from "./issueReplyInput.vue?vue&type=script&lang=ts&"
export * from "./issueReplyInput.vue?vue&type=script&lang=ts&"
import style0 from "./issueReplyInput.vue?vue&type=style&index=0&id=f86825d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86825d4",
  null
  
)

export default component.exports